import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { NavigationService } from 'app/core/services/navigation.service';
import { UserService } from 'app/core/services/user.service';

@Injectable({ providedIn: 'root' })
export class InitialDataResolver implements Resolve<any> {
  /**
   * Constructor
   */
  constructor(
    private navigationService: NavigationService,
    private user$: UserService
  ) {
  }

  resolve(): Observable<any> {

    // Fork join multiple API endpoint calls to wait all of them to finish
    return new Observable<any>(subscriber => {
      this.user$.getUser().subscribe(result => {
        if (result) {
          this.navigationService.get().subscribe(() => {

            subscriber.next();
            subscriber.complete();
          });
        } else {
          subscriber.next();
          subscriber.complete();
        }
      });
    });
  }
}
